import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const auditLogEntityAdapter: EntityAdapter = {
  entity: "auditlog",
  defaultSort: { sort: "-timestamp", tableSort: "timestamp", descending: true },
  persistsGlobalSearch: false,
};
